import { NLP_STAGE } from 'actions/searchNLP';

// All session-scoped reads go through the pointers: no active session means the UI sees
// empty/null, regardless of what records remain in the map.
const getActiveSession = state =>
  (state.activeSessionId && state.sessions.byId[state.activeSessionId]) || null;

export const getPendingSearchView = state => state.pendingSearchView;

export const getShowNLPFilterModal = state => !!state.showNLPFilterModal;

export const getNLPModalState = state => state.nlpModal;

export const getAISearchData = state =>
  getActiveSession(state)?.provenance ?? null;

// The generation on screen while the modal shows the stage-two review, else null.
const getReviewingSession = state =>
  state.showNLPFilterModal &&
  state.nlpModal.stage === NLP_STAGE.REVIEW &&
  state.nlpModal.aiSearchInterpretation &&
  state.pendingSessionId
    ? state.sessions.byId[state.pendingSessionId] || null
    : null;

// One session record by explicit id, for surfaces that hold their own pointer
// (the org profile stamps the applied session id onto its filters slice).
export const getAiSession = (state, sessionId) =>
  (sessionId && state.sessions.byId[sessionId]) || null;

// Feedback targets the generation on screen in the stage-two review when there is one;
// otherwise the last confirmed AI search. Both come from the session records captured as the
// data arrived, so the payload stays whole regardless of later session ends.
export const getAiFeedbackSubject = state =>
  getReviewingSession(state) || getAiSession(state, state.confirmedSessionId);

// The confirmed pointer is global and persisted; on a profile only the session it applied counts.
export const getOrgAiFeedbackSubject = (state, orgSessionId) =>
  getReviewingSession(state) || getAiSession(state, orgSessionId);

export const getShowAISearchFeedbackModal = state =>
  !!state.showAISearchFeedbackModal;

export const getRecentSearches = state => state.recentSearches;

// Stable empty values so selectors keep referential identity when no session is active
// (a fresh object each call would re-fire subscribers on every dispatch).
const EMPTY_MESSAGES = [];
const EMPTY_FOLLOW_UPS = {
  sessionId: null,
  fingerprint: null,
  queries: [],
  count: 0,
};

export const getConversationalMessages = state =>
  getActiveSession(state)?.conversationMessages ?? EMPTY_MESSAGES;

export const getFollowUpQueries = state =>
  getActiveSession(state)?.followUps ?? EMPTY_FOLLOW_UPS;

// Feedback telemetry for one session, read by the feedback modal at submit time. Keyed by an
// explicit id (pending wins over active there), not the active pointer.
export const getSessionFeedback = (state, sessionId) =>
  (sessionId && state.sessions.byId[sessionId]?.feedback) || null;

// Session IDs
export const getPendingAiSessionId = state => state.pendingSessionId;
export const getActiveAiSessionId = state => state.activeSessionId;
